import { AgResourceLanguage } from '../types';

export const paymentModalWIndow: AgResourceLanguage['paymentModalWIndow'] = {
  stripeCardField: {
    expiredLabel: 'Expirada'
  },
  paymentMethodMissing: {
    noPaymentMethodCharged: 'Ningún método de pago cargado',
    missingPaymentMethod: 'Método de pago faltante'
  }
};
